import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'
import { useMount } from 'react-use'

import Button from '../components/UI/Button'

import styles from '../styles/sections/Intro.module.css'

const Intro = props => {
  const [isSectionVisible, setIsSectionVisible] = useState(false)
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const contentWrapperClassName = classnames('container', styles.contentWrapper)
  const contentClassName = classnames(styles.content, {
    [styles.contentVisible]: isSectionVisible
  })
  const containerClassName = classnames('section', styles.container)
  const imageClassName = classnames(styles.image, {
    [styles.imageLoaded]: isImageLoaded
  })
  const aboutSectionId = props.about.frontmatter.id
  const onButtonClick = event => {
    event.preventDefault()
    document.getElementById(aboutSectionId).scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }

  useMount(() => {
    setTimeout(() => {
      setIsSectionVisible(true)
    }, 400)

    setTimeout(() => {
      if (!isImageLoaded) {
        setIsImageLoaded(true)
      }
    }, 800)
  })

  return (
    <section id={props.markdownRemark.frontmatter.id} className={containerClassName}>
      <div className={contentWrapperClassName}>
        <div className={contentClassName}>
          <h1 className={styles.title}>
            {props.markdownRemark.frontmatter.title}
            <small className={styles.subtitle}>{props.markdownRemark.frontmatter.subtitle}</small>
          </h1>

          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: props.markdownRemark.html }}
          />

          <Button
            containerElement='a'
            onClick={onButtonClick}
            className={styles.button}
            href={`#${aboutSectionId}`}
          >
            Saiba mais
          </Button>
        </div>

        <figure className={styles.imageWrapper}>
          <img
            src='intro/banana.png'
            className={imageClassName}
            alt={props.site.siteMetadata.title}
          />
        </figure>
      </div>
    </section>
  )
}

Intro.propTypes = {
  markdownRemark: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string
    }),
    html: PropTypes.string
  }),
  about: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      title: PropTypes.string
    })
  })
}

const introQuery = graphql`
  query IntroQuery {
    markdownRemark(frontmatter: { id: { eq: "intro" } }) {
      frontmatter {
        id
        title
        subtitle
      }
      html
    }
    about: markdownRemark(frontmatter: { id: { eq: "about" } }) {
      frontmatter {
        id
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default () => <StaticQuery query={introQuery} render={data => <Intro {...data} />} />
